import { useQuery } from "react-query";
import API from "../../Config/axios";
import { QUERY_KEY } from "../../Constants/query-keys";

const onGetDailyVisitor = async () => {
  const { data } = await API.get("/getDailyVisitor");
  return data;
};

const useGetDailyVisitor = () => {
  return useQuery([QUERY_KEY.GET_DAILY_VISITOR], onGetDailyVisitor);
};

export default useGetDailyVisitor;
